import { useFormContext } from "react-hook-form";
import { Button, Input, Navbar, NavbarBrand } from "reactstrap";
import { styled } from "styled-components";
import { useLocation } from "react-router-dom";

import HeaderIcon from "../assets/images/brush.png";
import AppRoutes from "../constants/routes";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px;
`;

const Export = styled(Button)`
  margin-left: 10px;
  background: #ec440c;
  border-color: #ec440c;
  padding: 5px 20px;
  border-radius: 5px;
  color: white;
`;

const HeaderImage = styled.img`
  margin-right: 10px;
  width: 30px;
  height: 30px;
`;

const StyledNavBar = styled(NavbarBrand)`
  display: flex;
  flex-direction: row;
  align-items: center;

  > h3 {
    font-weight: 600;
    margin-bottom: 0;
  }

  img {
    cursor: pointer;
  }
`;

const FilePicker = styled(Input)`
  margin-left: 10px;
`;

export default function NavHeader() {
  const { watch, formState, reset } = useFormContext();
  const { isValid } = formState;
  const values = watch();

  const location = useLocation();
  const isOrderWebWL = location.pathname.includes(AppRoutes.OrderWebWL);
  const isOrderAppWL = location.pathname.includes(AppRoutes.OrderAppWL);

  function getTitle() {
    if (isOrderWebWL) {
      return "Order Web White Label Themer";
    }
    if (isOrderAppWL) {
      return "Order App White Label Themer";
    }
    return "Ancon Order Themer";
  }

  function handleExport() {
    const dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(values));
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", "colors.json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  function handleImportFileChange({
    target: { files },
  }: React.ChangeEvent<HTMLInputElement>) {
    const cancel = !files?.length;
    if (cancel) return;

    const firstFile = files[0];
    const { name } = firstFile;

    if (name.includes(".json")) {
      try {
        let reader = new FileReader();
        reader.onload = function () {
          const data = reader.result;
          if (typeof data === "string") {
            const parsedData = JSON.parse(data);
            reset(parsedData);
          }
        };

        reader.readAsText(firstFile);
      } catch (error) {
        console.error(error);
      }
    } else {
      alert("Invalid file type. Please upload a .json file.");
    }
  }

  function handleNavigateToHome() {
    window.location.href = "/";
  }

  return (
    <Navbar color="dark" dark>
      <StyledNavBar>
        <HeaderImage src={HeaderIcon} onClick={handleNavigateToHome} />
        <h3>{getTitle()}</h3>
      </StyledNavBar>
      <Container>
        <Export disabled={!isValid} onClick={handleExport}>
          Export
        </Export>
        <FilePicker type="file" onChange={handleImportFileChange} />
      </Container>
    </Navbar>
  );
}
